import React, { useEffect, useState } from "react";
import { ChevronUpIcon } from "@heroicons/react/solid";
import api from "../utils/api";

const Terminos = () => {
  const [sections, setSections] = useState([]);
  const [openSection, setOpenSection] = useState(null); // Track the open section

  useEffect(() => {
    api.get("/terminos")
      .then((res) => {
        setSections(res.data);
        // Open the first section by default
        if (res.data.length > 0) {
          setOpenSection(res.data[0].id);
        }
      })
      .catch((err) => console.error("Error al cargar términos:", err));
  }, []);

  const toggleSection = (id) => {
    setOpenSection((prev) => (prev === id ? null : id)); // Toggle: close if same, open new and close others
  };

  return (
    <div className="max-w-4xl mx-auto py-10 px-6">
      <h1 className="text-3xl font-bold text-gray-900 text-center mb-6">
        Términos y Condiciones
      </h1>
      <p className="text-gray-700 text-lg text-center mb-8">
        Conoce las condiciones y políticas de uso de nuestros servicios.
      </p>

      <div className="w-full mx-auto space-y-4">
        {sections.map((section) => (
          <div key={section.id}>
            <button
              onClick={() => toggleSection(section.id)}
              className="flex justify-between w-full px-4 py-3 text-lg font-medium text-left text-gray-900 bg-gray-100 rounded-lg hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-blue-500 focus-visible:ring-opacity-75"
            >
              <span>{section.section_title}</span>
              <ChevronUpIcon
                className={`w-6 h-6 transition-transform ${openSection === section.id ? "rotate-180" : ""} text-blue-500`}
              />
            </button>
            {openSection === section.id && (
              <div className="px-4 pt-4 pb-2 text-gray-700">
                <div dangerouslySetInnerHTML={{ __html: section.section_html }} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Terminos;